import React, { useCallback, useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useNavigate } from 'react-router-dom';
import SelfAssessmentUsersTable from './SelfAssessmentUsersTable';
import { SidebarContext } from '../../../../context/SidebarContext';
import { useCompanySectionFilter } from '../../../../component/B2B/CompanySectionLayout';
import { getLocalStorageItem } from '../../../../utils/helper';
import { fetchCompanySelfAssessmentUsers } from './companySelfAssessmentApi';

/**
 * Company Self-Assessment → Employees/Members list.
 * Every user of the current population appears (those who have never taken an
 * assessment show dashes and sort last); a row opens their assessment profile.
 */
const CSelfAssessmentUsers = () => {
  const navigate = useNavigate();
  const { isB2BFansMode } = useContext(SidebarContext);
  const { department } = useCompanySectionFilter();
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const fetcher = useCallback(
    (params) => fetchCompanySelfAssessmentUsers({ ...params, department }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isB2BFansMode, department]
  );

  return (
    <div>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Self-Assessment — {isB2BFansMode ? 'Members' : 'Employees'} | Shoorah</title>
      </Helmet>

      <p className="text-sm text-gray-500 dark:text-gray-400 mb-3">
        Your {isB2BFansMode ? 'members' : 'employees'} and how they use self-assessments. Open a
        user to see which ones they take and anything they left half-finished.
      </p>

      <SelfAssessmentUsersTable
        fetcher={fetcher}
        onOpenUser={(rowData) => navigate(`/${slug}/self-assessment/user?userId=${rowData?._id}`)}
        tableName="company_self_assessment_users"
      />
    </div>
  );
};

export default CSelfAssessmentUsers;
